import { getAuth } from "firebase/auth";

export async function getIdToken() {
  return await getAuth().currentUser?.getIdToken();
}
